//
//
//
//
//
//
//
//
//
// import Hash from "../../utils/hash";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  computed: {
    cssClasses: function cssClasses() {
      var classes = this.$classes().concat("layouts-scroll");
      return classes;
    },
    cssStyles: function cssStyles() {
      // // Let the styles be handled by the child panel.
      // const outerSpec = {};
      // outerSpec["padding"] = this.spec["outerPadding"];
      // console.log("outerSpec", outerSpec);
      // const styles = this.$styles(outerSpec);
      //
      // const styles = this.genericStyles();
      // styles.remove("padding-top");
      // styles.remove("padding-bottom");
      // styles.remove("padding-left");
      // styles.remove("padding-right");
      //
      // const styles = this.$styles({
      //   width: this.spec.width,
      //   height: this.spec.height
      // });
      //
      // console.log("styles", styles);
      // Let the specified styles be handled by the child panel.
      var styles = this.$styles({
        width: "matchParent"
      });
      return styles;
    }
  }
};